import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyBillWave, faCircle, faUndo } from '@fortawesome/free-solid-svg-icons'


const Billetes = ({ CambiaValorImporte, CambiaValorImporteReset }) => {

	return (
		<div className="row">
			<div className="cont_billetes">
				<button onClick={CambiaValorImporte(1)} className="btn_billete">
					<FontAwesomeIcon icon={faMoneyBillWave} /> $1
				</button>
				<button onClick={CambiaValorImporte(5)} className="btn_billete">
					<FontAwesomeIcon icon={faMoneyBillWave} /> $5
				</button>
				<button onClick={CambiaValorImporte(10)} className="btn_billete">
					<FontAwesomeIcon icon={faMoneyBillWave} /> $10
				</button>
				<button onClick={CambiaValorImporte(20)} className="btn_billete">
					<FontAwesomeIcon icon={faMoneyBillWave} /> $20
				</button>
				<button onClick={CambiaValorImporte(50)} className="btn_billete">
					<FontAwesomeIcon icon={faMoneyBillWave} /> $50
				</button>
				<button onClick={CambiaValorImporteReset(0)} className="btn_reset">
					<FontAwesomeIcon icon={faUndo} />
				</button>
				<button onClick={CambiaValorImporte(100)} className="btn_billete">
					<FontAwesomeIcon icon={faMoneyBillWave} /> $100
				</button>
				<button onClick={CambiaValorImporte(200)} className="btn_billete">
					<FontAwesomeIcon icon={faMoneyBillWave} /> $200
				</button>
				<button onClick={CambiaValorImporte(0.01)} className="btn_moneda">
					<FontAwesomeIcon icon={faCircle} /> $0.01
				</button>
				<button onClick={CambiaValorImporte(0.05)} className="btn_moneda">
					<FontAwesomeIcon icon={faCircle} /> $0.05
				</button>
				<button onClick={CambiaValorImporte(0.10)} className="btn_moneda">
					<FontAwesomeIcon icon={faCircle} /> $0.10
				</button>
				<button onClick={CambiaValorImporte(0.20)} className="btn_moneda">
					<FontAwesomeIcon icon={faCircle} /> $0.20
				</button>

			</div>
		</div>
	)
}



export default Billetes